// The purpose of this module is to handle the builder filters in the
// Homes and Plans section for MPC

(function builderFiltersHandler(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};

  const previousModule = global.NewHomeSource.BuilderFiltersHandler;

  const homesContainer = document.querySelector('[data-homes-container]');

  /**
   * @constructs NewHomeSource.MpcEventsHelper
   */
  function BuilderFiltersHandler() {
  }

  /**
   * Converts a nodeList to array type in order to use
   * array.prototype.forEach instead of nodeList.prototype.foreach
   * @param {nodeList} nodeList A nodeList
   * @returns {array} The nodeList converted to array
   */
  function nodeListToArray(nodeList) {
    return Array.prototype.slice.call(nodeList);
  }

  /**
   * Gets a list of the builder ids selected as filters.
   * If no filters was selected, returns all builder ids, since we want to display all results in that case.
   */
  function getSelectedBuilderFilterIds() {
    let selectedBuilderIds = [];
    const builderFilters = document.querySelectorAll('[data-builder-filter]');

    if (builderFilters) {
      const selectedBuilders = document.querySelectorAll('[data-builder-filter]:checked');
      let filterElements;

      if (selectedBuilders.length === 0) {
        filterElements = builderFilters;
      } else {
        filterElements = selectedBuilders;
      }

      for (let i = 0; i < filterElements.length; i += 1) {
        selectedBuilderIds.push(filterElements[i].getAttribute('data-builder-id'));
      }
    }

    return selectedBuilderIds;
  }

  /**
   * Display or hides the home cards depending if the filter active or not.
   * @param {any} event
   */
  function filterHomesByBuilder() {
    const selectedBuilderFilterIds = getSelectedBuilderFilterIds();
    let allHomeCards = document.querySelectorAll('[data-home-section-item]');
    allHomeCards = nodeListToArray(allHomeCards);

    allHomeCards.forEach(function (element) {
      if (selectedBuilderFilterIds.indexOf(element.getAttribute('data-builder-id')) > -1) {
        element.style.display = 'block';
      } else {
        element.style.display = 'none';
      }
    });
  }
  
  /**
   * Updates the counters in the tabs after applying a builder filter.
   */
  function updateFilterTabs() {
    let tabFilterContainers = document.querySelectorAll('[data-tab-filter]');
    tabFilterContainers = nodeListToArray(tabFilterContainers);

    tabFilterContainers.forEach(function (element) {
      const customFilterValue = element.getAttribute('data-custom-filter-type');
      const homeStatusFilter = element.getAttribute('data-home-status-type');
      const tabLabel = element.querySelector('label');
      const tabInput = element.querySelector('input');
      let homesByTypeCount = '';

      if (customFilterValue === 'all') {
        homesByTypeCount = document.querySelectorAll('[data-home-section-item][style="display: block;"]').length;
      }
      else if (customFilterValue === 'luxury') {
        homesByTypeCount = homesContainer.querySelectorAll('[data-luxury="1"][style="display: block;"]').length;
      }
      else if (customFilterValue === 'matching-home') {
        homesByTypeCount = homesContainer.querySelectorAll('[data-is-matching-home="true"][style="display: block;"]').length;
      }
      else if (homeStatusFilter) {
        homesByTypeCount = homesContainer.querySelectorAll('[data-home-status-type="' + homeStatusFilter + '"][style="display: block;"]').length;
      }
      tabInput.setAttribute("data-cards", homesByTypeCount);
      let counterText = element.getAttribute('data-tab-title') + ' (' + homesByTypeCount + ')';
      tabLabel.textContent = counterText;
    });
  }

  /**
   * Hides all home cards
   */
  function hideAllHomeCards(event) {
    let cardsToDisable = document.querySelectorAll('[data-home-section-item]');
    cardsToDisable = nodeListToArray(cardsToDisable);

    cardsToDisable.forEach(function (element) {
      element.style.display = 'none';
    });
  }

  function filterByCurrentTab() {
    const selectedTab = document.querySelector('[data-tab-filter] input:checked');
    selectedTab.click();
  }

  /**
   * @public
   * 
   */
  BuilderFiltersHandler.setBuilderFiltersEvents = function () {
    const builderFilterElements = document.querySelectorAll('[data-builder-filter]');

    for (let i = 0; i < builderFilterElements.length; ++i) {
      const builderFilter = builderFilterElements[i];
      builderFilter.addEventListener('change', function (event) {
        hideAllHomeCards();
        filterHomesByBuilder(event);
        updateFilterTabs();
        filterByCurrentTab();
      });
    }
  };

  BuilderFiltersHandler.init = function() {
    BuilderFiltersHandler.setBuilderFiltersEvents();
  }

  /**
   * @public
   * noConflict: Returns control of NewHomeSource.SampleModule to the previous script.
   */
  BuilderFiltersHandler.noConflict = function noConflict() {
    global.NewHomeSource.BuilderFiltersHandler = previousModule;
    return BuilderFiltersHandler;
  };

  global.NewHomeSource.BuilderFiltersHandler = BuilderFiltersHandler;

  BuilderFiltersHandler.init();

  return BuilderFiltersHandler;
}(window));
